module.exports = __webpack_public_path__ + "static/ogpImage_ssd-yah40th-9fdf0bb65564c042a12dccf799e69434.png";